export const ru = {
    nav: {
      about: 'О нас',
      tours: 'Путешествия',
      realEstate: 'Недвижимость',
      news: 'Новости',
      insights: 'Инвестиционный обзор',
      contact: 'Контакты',
      tourDropdown: {
        dayTours: 'Дневные туры по Стамбулу',
        shoreExcursions: 'Круизные экскурсии',
        foodTour: 'Гастрономический тур',
        reConsulting: 'Консультации по недвижимости (Бесплатно)',
        layoverTour: 'Транзитные туры',
        medicalTourism: 'Медицинский туризм'
      },
      realEstateDropdown: {
        besiktas: 'Бешикташ',
        florya: 'Бакыркёй',
        kanalIstanbul: 'Канал Стамбул',
        skyland: 'Крупный небоскрёб',
        merkezefendi: 'Зейтинбурну',
        tualComfort: 'Канал Стамбул 2-й',
        referansBeylikduzu: 'Элитные резиденции на европейской стороне'
      }
    },
    hero: {
      title: 'Ваш путь в Стамбул',
      subtitle: 'Инвестиции и Туризм',
      motto: '"Мы ваш надежный партнер в Турции"',
      exploreTours: 'Обзор туров',
      viewProperties: 'Посмотреть объекты'
    },
    about: {
      title: 'О Viaturkey',
      intro: 'Viaturkey - это компания полного цикла в Стамбуле, специализирующаяся на туризме, консалтинге и консультационных услугах по недвижимости в Стамбуле и по всей Турции.',
      tourism: 'Туристические услуги',
      tourismDesc: 'Комплексные туристические услуги в Стамбуле и Турции, адаптированные под ваши потребности.',
      realEstate: 'Консультации по недвижимости',
      realEstateDesc: 'Экспертное руководство по инвестициям в турецкую недвижимость.',
      realEstateExtra: 'Услуги по управлению недвижимостью также могут быть предоставлены по запросу и с доверенностью.',
      residence: 'Вид на жительство',
      residenceDesc: 'Профессиональная помощь в оформлении вида на жительство в Турции.',
      citizenship: 'Турецкое гражданство',
      citizenshipDesc: 'Полная поддержка в процессе получения турецкого гражданства.',
      establishBusiness: 'Регистрация бизнеса',
      establishBusinessDesc: 'Экспертная помощь в регистрации и открытии вашего бизнеса в Турции.',
      workPermit: 'Получение разрешения на работу',
      workPermitDesc: 'Комплексное сопровождение в оформлении разрешений на работу для иностранных граждан в Турции.',
      founderGreeting: 'Здравствуйте, я сооснователь Viaturkey Investments & Tourism Co. Меня зовут Акын Гюзель. Я серийный предприниматель в сфере туристических операций и консультирования по недвижимости, а также надёжный местный бизнес-партнёр, базирующийся в Стамбуле, Турция. С нашей командой экспертов на местах, мы с нетерпением ждём возможности обсудить ваши планы в Турции.',
      founderName: 'Акын Гюзель',
      founderTitle: 'Сооснователь, Viaturkey Investments & Tourism Co.'
    },
    interestField: {
      title: 'Ваша сфера интересов в Турции',
      travel: 'Путешествия Viaturkey',
      travelDesc: 'Исследуйте Стамбул с частными турами и опытными местными гидами',
      invest: 'Инвестиции Viaturkey',
      investDesc: 'Элитная недвижимость и инвестиционные возможности в Стамбуле',
      news: 'Новости Viaturkey',
      newsDesc: 'Последние новости о жизни и бизнесе в Турции',
      insights: 'Инвестобзор Viaturkey',
      insightsDesc: 'Мегапроекты Стамбула, данные рынка и показатели туризма для инвесторов',
    },
    tours: {
      title: 'Туристические услуги',
      subtitle: 'Исследуйте Стамбул и Турцию с местными экспертами-гидами',
      whyBookTitle: 'Почему стоит бронировать у нас?',
      bestPrice: 'Гарантия лучшей цены – бронируйте напрямую и экономьте',
      bestPriceDesc: 'Обращаясь к нам напрямую через наш сайт или по электронной почте, вы обходите сторонние платформы, такие как TripAdvisor / Viator / Get Your Guide, которые взимают комиссию до 25%. Мы предпочитаем передавать эту экономию вам в виде скидки при прямом бронировании.',
      tailorMade: 'Индивидуальные маршруты',
      tailorMadeDesc: 'Ваше путешествие не должно быть универсальным. Будь то конкретная историческая достопримечательность или скрытая жемчужина, о которой вы мечтали, мы специализируемся на настройке каждой детали в соответствии с вашими личными интересами.',
      expertGuides: 'Опытные местные гиды',
      expertGuidesDesc: 'Наши самые популярные гиды часто пользуются большим спросом, и их расписание быстро заполняется. Бронирование заранее гарантирует, что вы получите предпочитаемую дату и время с первоклассным профессионалом.',
      transparency: 'Полная прозрачность',
      transparencyDesc: 'Никаких скрытых платежей или сюрпризов. Мы предоставляем четкие детали вашего маршрута, продолжительности и того, что именно включено. Вы всегда будете знать условия и политику отмены перед тем, как завершить свое приключение.',
      duration: 'Продолжительность',
      highlights: 'Основные моменты',
      included: 'Включено',
      excluded: 'Не включено',
      contactPrice: 'Свяжитесь для лучшей цены',
      inquireNow: 'Запросить сейчас',
      alsoAvailable: 'Также доступны',
      flexibleToursIntro: 'Туры по христианскому наследию, археологические туры и шопинг-туры также могут быть организованы с гибким маршрутом в вашем темпе в соответствии с вашими планами.',
      flexibleToursContact: 'Пожалуйста, свяжитесь с нами для получения подробной информации',
      christianHeritage: 'Туры по христианскому наследию',
      archaeologyTours: 'Археологические туры',
      shoppingTours: 'Шопинг-туры',
      pricingBanner: 'Частное культурное сопровождение - Организация туров от $160 за группу от 2 до 8 человек.',
      pricingSolo: 'Пожалуйста, запросите цену для индивидуальных путешественников или FIT / Инсентив групп.',
      priceFrom200: 'От $200 USD',
      priceFrom150: 'От $150 USD с человека',
      priceFrom175: 'От $175 за группу',
      priceFrom160: 'От $160 за группу',
      priceFrom185: 'От $185 за группу',
      contactWhatsApp: 'Связаться через WhatsApp',
      commissionWarning: {
        title: 'Важное уведомление',
        message: 'Обратите внимание, что эти 3 веб-сайта берут 25% комиссии с человека от стоимости тура, при этом вы фактически платите деньги третьим сторонам, которые не участвуют ни в реальных операциях, ни в экспертизе, ни в усилиях вообще!',
        directMessage: 'Бронируя напрямую у нас, ваши деньги идут непосредственно поставщику услуг — без посредников и скрытых комиссий.'
      },
      businessDining: {
        tip: 'Советы для деловых путешественников в Стамбуле',
        title: 'Лучшие рестораны Стамбула для деловых встреч',
        specialty: 'Специализация',
        steakhouseTitle: 'Стейкхаусы и кебаб-рестораны',
        seafoodTitle: 'Босфор и рестораны на набережной',
        italianTitle: 'Изысканная мировая и итальянская кухня',
        fineDiningTitle: 'Рестораны с панорамным видом'
      },
      videoSection: {
        title: 'Исследуйте Стамбул с нами',
        desc: 'Присоединяйтесь к нашей экскурсии по самым знаковым достопримечательностям Стамбула — величественной Голубой мечети и исторической Айя-Софии. Откройте для себя богатую историю, потрясающую архитектуру и культурное наследие.'
      },
      realEstateConsulting: {
        title: 'Услуга консультирования по недвижимости',
        vanInfo: 'Частный фургон с водителем может быть организован за дополнительную плату.',
        consultingInfo: 'Предоставляется минимум 3-5 часов бесплатного консультирования по недвижимости.',
        description: 'Эта услуга может быть предоставлена гостям (по специальному запросу), которые хотят получить максимально подробное представление о рынке недвижимости и инвестиций в Стамбуле.',
        ctaText: 'Запланируйте 15-минутный звонок, чтобы обсудить ваши инвестиционные планы в Турции'
      },
      includedItems: [
        'Частный персональный гид',
        'Быстрый вход во все музеи (кроме Айя-Софии)',
        'Профессиональный гид',
        'Продолжительность тура 5-8 часов',
        'Трансфер от отеля с/без кондиционированного транспорта'
      ],
      excludedItems: [
        'Чаевые гиду',
        'Входные билеты во все музеи',
        'Обед',
        'Все виды расходов во время тура'
      ],
      tourDetails: {
        '1': {
          name: 'Ежедневный тур по Старому городу Стамбула',
          description: 'Исследуйте историческое сердце Стамбула с посещением знаковых достопримечательностей. Минимум 5-8 часов с опытным местным гидом, который расскажет всю историю с анекдотами, традициями и реальными историями.',
          duration: 'Минимум 5-8 часов',
          highlights: ['Айя-София', 'Голубая мечеть', 'Дворец Топкапы', 'Гранд-базар', 'Ипподром'],
          whatsappMsg: 'Здравствуйте, меня интересует тур по Старому городу Стамбула. Не могли бы вы предоставить подробности?',
          details: '**Информация о ценах на тур:**\nОсновная указанная цена будет за пешеходную экскурсию по музеям с экспертным профессиональным гидом. Если вам требуется специальный автомобиль или фургон с кондиционером, будет добавлена дополнительная цена.\n\n**Возможные места для посещения:**\n• Музей Айя-София (25 EUR/чел.) - Христианский собор 6 века, превращенный в мечеть в 15 веке османами, в настоящее время используется как полумузей и полумечеть\n• Султанахмет (Голубая мечеть) - БЕСПЛАТНО - Красиво украшенная османская мечеть 17 века с самой большой коллекцией керамики в Стамбуле\n• Ипподром - БЕСПЛАТНО - Открытая площадь, называемая Площадь лошадей в османский период, включает самые старые стоящие колонны в Стамбуле\n• Подземная цистерна Базилика (45 USD/чел.) - Использовалась как резервуар для воды в римский период, построена в 6 веке в эпоху Юстиниана, сейчас музей\n• Музей дворца Топкапы (63 USD/чел.) - Дом султанов с 15 по начало 19 века, сейчас используется как музей\n• Гранд-базар - БЕСПЛАТНО - Более 3000 торговцев, включая магазины ковров, ювелиров, специй и многое другое!\n\n**Альтернативные варианты:**\n• Базар специй - БЕСПЛАТНО - Датируется 17 веком, более 90 активных торговцев\n• Круиз по Босфору - 300 турецких лир на человека за 1,5 часа'
        },
        '2': {
          name: 'Береговые экскурсии - тур по Старому городу Стамбула',
          description: 'Идеально для пассажиров круизов! Комплексная экскурсия по Старому городу Стамбула с удобным трансфером от/до порта. Минимум 5-8 часов с опытным местным гидом.',
          duration: 'Минимум 5-8 часов',
          highlights: ['Встреча в порту', 'Достопримечательности Старого города', 'Возвращение в порт'],
          whatsappMsg: 'Здравствуйте, меня интересуют береговые экскурсии. Не могли бы вы предоставить подробности?',
          details: '**Информация о ценах на тур:**\nОсновная указанная цена будет за пешеходную экскурсию по музеям с экспертным профессиональным гидом. Если вам требуется специальный автомобиль или фургон с кондиционером, будет добавлена дополнительная цена.\n\n**Возможные места для посещения:**\n• Музей Айя-София (25 EUR/чел.) - Христианский собор 6 века, превращенный в мечеть в 15 веке османами, в настоящее время используется как полумузей и полумечеть\n• Султанахмет (Голубая мечеть) - БЕСПЛАТНО - Красиво украшенная османская мечеть 17 века с самой большой коллекцией керамики в Стамбуле\n• Ипподром - БЕСПЛАТНО - Открытая площадь, называемая Площадь лошадей в османский период, включает самые старые стоящие колонны в Стамбуле\n• Подземная цистерна Базилика (45 USD/чел.) - Использовалась как резервуар для воды в римский период, построена в 6 веке в эпоху Юстиниана, сейчас музей\n• Музей дворца Топкапы (63 USD/чел.) - Дом султанов с 15 по начало 19 века, сейчас используется как музей\n• Гранд-базар - БЕСПЛАТНО - Более 3000 торговцев, включая магазины ковров, ювелиров, специй и многое другое!\n\n**Альтернативные варианты:**\n• Базар специй - БЕСПЛАТНО - Датируется 17 веком, более 90 активных торговцев\n• Круиз по Босфору - 300 турецких лир на человека за 1,5 часа'
        },
        '3': {
          name: 'Туры во время пересадки из аэропортов Стамбула / Сабихи Гёкчен',
          description: 'Максимально используйте время пересадки! Индивидуальные туры из аэропорта Стамбула и аэропорта Сабихи Гёкчен.',
          duration: '4-8 часов (гибкий график)',
          highlights: ['Встреча и доставка в аэропорт', 'Гибкий маршрут', 'Главные достопримечательности', 'Время для шоппинга'],
          whatsappMsg: 'Здравствуйте, меня интересует тур во время пересадки в Стамбуле. Вот мои данные рейса:\nНомер рейса прибытия: \nНомер рейса вылета: \nДлительность пересадки: \nВремя для экскурсии: Примерно ___ часов\nКоличество человек: ',
          details: 'Пожалуйста, сообщите нам данные вашего рейса в Стамбул и другие детали:\n\nДанные прибытия и рейса:\n• Номер рейса прибытия: ............\n• Номер рейса вылета: ............\n• Длительность пересадки: ............\n• Время для экскурсии: Примерно ......... часов\n\nВариант тура: Полный дневной тур во время пересадки (Приватный)\nКомфортное и расслабленное знакомство со Стамбулом с местным гидом, идеально для тех, кто впервые в городе.\n\nПредлагаемый маршрут:\n• Встреча в аэропорту после паспортного контроля\n• Трансфер в Султанахмет (Старый город)\n• Посещение Голубой мечети, Айя-Софии и площади Ипподром\n• Остановка на Араста-базаре или Базаре специй\n• Паромная прогулка по Босфору на азиатскую сторону (по желанию и при наличии времени)\n• Турецкий ужин (за свой счёт) или дегустация местной уличной еды\n• Трансфер обратно в аэропорт'
        },
        '4': {
          name: 'Гастрономический тур по Стамбулу - вкус 2 континентов',
          description: 'Кулинарное путешествие по европейской и азиатской части Стамбула. Познайте подлинную турецкую кухню и местные вкусы.',
          duration: '5-6 часов',
          highlights: ['Традиционный турецкий завтрак', 'Уличная еда', 'Местные рынки', 'Переправа через Босфор', 'Сладости'],
          whatsappMsg: 'Здравствуйте, меня интересует гастрономический тур по Стамбулу. Не могли бы вы предоставить подробности?',
          details: 'Минимум 5-8 остановок, включая:\n• Традиционный турецкий завтрак\n• Минимум 3 гарнира\n• 1 основное блюдо\n• Особые местные десерты\n\nВаш гид, как местный гурман, опишет интересные истории и анекдоты, предоставляя обширную презентацию турецкой кухни.\n\nПожалуйста, свяжитесь для получения расценок на человека.'
        },
        '5': {
          name: 'Трансфер из аэропортов Стамбула / Сабихи Гёкчен',
          description: 'Комфортные и надежные услуги трансфера из аэропорта. Частные автомобили с профессиональными водителями.',
          duration: 'По необходимости',
          highlights: ['Услуга «от двери до двери»', 'Профессиональные водители', 'Современные автомобили', 'Доступно 24/7', 'Отслеживание рейсов'],
          whatsappMsg: 'Здравствуйте, меня интересуют услуги трансфера из аэропорта. Не могли бы вы предоставить расценки?',
          includedItems: [
            'Встреча и приветствие в аэропорту',
            'Услуга «от двери до двери»',
            'Профессиональные водители',
            'Современные автомобили с кондиционером - Прохладительные напитки в автомобиле',
            'Доступно 24/7',
            'Отслеживание рейсов'
          ],
          excludedItems: [
            'Цены от 1-4 пассажиров',
            'Цены для 5-10 пассажиров',
            'Цены для 11 и более',
            'Пожалуйста, свяжитесь с нами для расчёта стоимости'
          ]
        }
      }
    },
    realEstate: {
      title: 'Инвестиционные возможности',
      titleHighlight1: 'Инвестиционные',
      titleHighlight2: 'возможности',
      downloadBrochure: 'Скачать брошюру',
      requestInfo: 'Запросить информацию',
      discoveryCall: 'Запишитесь на 15-минутный ознакомительный звонок, чтобы обсудить ваши инвестиционные цели в Стамбуле и Турции.',
      moreProjects: 'Скоро появятся новые проекты...',
      officialResources: 'Официальные инвестиционные ресурсы',
      acquiringPropertyTitle: 'Приобретение недвижимости и гражданства в Турции',
      acquiringPropertyDesc: 'Официальное руководство по процедурам, документам и правилам для иностранных граждан.',
      citizenshipGuideTitle: 'Руководство по получению турецкого гражданства для иностранцев',
      citizenshipGuideDesc: 'Полное официальное PDF-руководство от Инвестиционного офиса Президентства Республики Турция.',
      residencePermitTitle: 'Получение вида на жительство',
      residencePermitDesc: 'Процедуры и необходимые документы для иностранных граждан для получения вида на жительство в Турции.',
      establishBusinessTitle: 'Открытие бизнеса',
      establishBusinessDesc: 'Информация о регистрации и открытии компании в Турции, включая типы и процесс создания.',
      workPermitTitle: 'Получение разрешения на работу',
      workPermitDesc: 'Руководство для иностранных граждан по получению разрешений на работу в Турции.',
      developer: 'Застройщик',
      status: 'Статус',
      apartmentTypes: 'Типы квартир',
      keyFeatures: 'Ключевые особенности',
      projectDetails: {
        'besiktas-luxury': {
          name: 'Роскошный жилой проект в Бешикташе',
          location: 'Шишли - Меджидиекёй, Стамбул',
          description: 'Роскошный жилой проект, сочетающий историческую текстуру Стамбула и современную жизнь, предлагающий эксклюзивный образ жизни с видом на Босфор. Застройщик Premium Developer.',
          highlights: [
            '175 квартир на 6 этажах',
            'Виды на Босфор, ландшафт и город',
            'Крытый бассейн, тренажерный зал, спа',
            'Охрана 24/7, крытая парковка',
            'Пешком до метро и паромной переправы',
            'Право на турецкое гражданство',
            'Право на вид на жительство'
          ]
        },
        'nivak-florya': {
          name: 'Ультра-роскошные резиденции в сердце района Бакыркёй',
          location: 'Бакыркёй, Стамбул',
          description: 'Образ жизни на уровне, которого вы действительно заслуживаете. Частное и бутиковое сообщество с вдохновленной природой архитектурой, искусственным озером и уникальными зелеными ландшафтами. Во всех резиденциях используются полностью европейские материалы, натуральное дерево и камень.',
          highlights: [
            'Всего 96 эксклюзивных квартир',
            'Высота потолков более 3,20 метров',
            'В нескольких шагах от побережья и набережного парка',
            'Рядом с парком Ататюрка',
            'Крытый бассейн, турецкая баня, сауна',
            'Фитнес-центр и студия пилатеса',
            'Футбольная и баскетбольная площадки',
            'Право на турецкое гражданство',
            'Готово к сдаче - июнь 2025'
          ]
        },
        'tual-golyaka-kanal': {
          name: 'Проект Резиденции Канал Стамбул',
          location: 'Европейская сторона Стамбула',
          description: 'Малоэтажный жилой проект, сочетающий современную городскую жизнь с природным дизайном. Расположен рядом с коридором Канала Стамбул, предлагая высокий потенциал будущей стоимости. Застройщик с государственной поддержкой и 70% зеленых зон.',
          highlights: [
            '26,000 кв.м. площади - 70% зеленых насаждений',
            'Горизонтальная малоэтажная архитектура',
            'Близко к озеру Кючюкчекмедже',
            'Легкий доступ к магистрали TEM',
            'Открытый бассейн и фитнес-центр',
            'Пешеходные и беговые дорожки',
            'Частные сады и большие террасы',
            'Охрана 24/7 с контролируемым входом',
            'Право на турецкое гражданство',
            'Рядом с коридором Канала Стамбул'
          ]
        },
        'alya-merkezefendi': {
          name: 'Новый проект в центре рядом с районом Фатих',
          location: 'Зейтинбурну, Стамбул',
          description: 'Современный жилой комплекс в центре Зейтинбурну, предлагающий комфортную городскую жизнь с отличным транспортным сообщением. 467 квартир на 6 этажах с богатой социальной инфраструктурой.',
          highlights: [
            '467 квартир и 15 коммерческих помещений',
            'Площадь участка 17 928 кв.м., площадь застройки 80 124 кв.м.',
            'Крытый бассейн, фитнес-зал',
            'Баскетбольная и футбольная площадки',
            'Турецкая баня, сауна, паровая баня',
            'Детские площадки и пешеходные дорожки',
            'Охрана 24/7, крытая парковка',
            '650 м до метробуса Cevizlibağ (пешая доступность)',
            'Право на турецкое гражданство',
            'Право на вид на жительство'
          ]
        },
        'skyland-prime': {
          name: 'Şişli Major Prime Gökdelen Rezidansı',
          location: 'Шишли - Маслак, Стамбул',
          description: 'Самый высокий жилой комплекс в Турции, расположенный между Левентом и Маслаком. Спроектирован архитектором Питером Воганом из Broadway Malyan, сочетая высокие технологии и инновационную архитектуру.',
          highlights: [
            'Самый высокий комплекс в Турции - 1 450 квартир',
            'Площадь застройки 46 000 кв.м.',
            'Центральное расположение между Левентом и Маслаком',
            'VIP-лобби и система «умный дом»',
            'Крытый и открытый бассейны',
            'Торговый центр, фуд-корт, тренажерный зал',
            'Турецкая баня, сауна, зал для пилатеса',
            'Охрана 24/7, трансфер, парковка',
            'Отдельный вход с автомагистрали ТЕМ',
            'Вид на лес и город - Немедленная сдача',
            'Право на турецкое гражданство'
          ]
        }
      }
    },
    investmentInsights: {
      title: 'Инвестиционный обзор: мегапроекты Стамбула и перспективы рынка',
      marketNews: 'Новости рынка и туризма',
    },
    news: {
      title: 'Новости бизнеса и образа жизни в Турции',
      tourismRevenue: {
        title: 'Турция превысила цель по доходам от туризма в 2025 году, иностранные прибытия побили рекорд',
        desc: '$65,2 млрд дохода от туризма с 64 миллионами туристов в 2025 году — оба показателя являются историческими рекордами.'
      },
      realEstateMarket: {
        title: 'Рынок недвижимости Турции — европейский лидер',
        desc: 'Турция — один из самых перспективных рынков недвижимости в Европе. Стратегически расположена на перекрёстке Европы, Ближнего Востока и Центральной Азии, с населением 85 млн. Приток ПИИ составил $11,3 млрд, а ПИИ в недвижимость — $2,8 млрд (25% всех ПИИ в 2024 г.).',
        cta: 'Подробнее здесь'
      },
      tourismRecord: {
        title: 'Турция установила рекордные показатели туризма несмотря на геополитические вызовы',
        desc: '64 млн туристов и $65,2 млрд дохода в 2025 — Турция стала 4-й по посещаемости страной мира.'
      }
    },
    kanalIstanbul: {
      sectionTitle: 'Проект Канал Стамбул',
      projectPurpose: 'Канал Стамбул - Цель проекта',
      projectPurposeDesc: 'Узнайте о целях и видении мегапроекта Канал Стамбул — альтернативного водного пути Босфору.',
      videos: 'Канал Стамбул - Видео и документальные фильмы',
      videosDesc: 'Смотрите официальные видео и документальные фильмы о развитии проекта Канал Стамбул.',
      arabicVideoTitle: 'Канал Стамбул - Документальный фильм на арабском',
      arabicVideoDesc: 'Смотрите документальный фильм о проекте Канал Стамбул на арабском языке.'
    },
    tersaneIstanbul: {
      sectionTitle: 'Терсане Стамбул',
      description: 'Терсане Стамбул — впечатляющий проект городской трансформации, превращающий крупнейший объект промышленного наследия Турции в современный прибрежный район мирового уровня. Проект возвышается на историческом месте Терсане-и Амире на северном берегу Золотого Рога и привносит новую жизнь с пятизвёздочными отелями, магазинами, музеями, культурными центрами, резиденциями, маринами и двухкилометровой набережной.',
      ourStory: 'Aliée Стамбул - Наша история',
      ourStoryDesc: 'Откройте для себя путь от исторической Османской верфи до утончённого направления мирового класса на Золотом Роге.',
      thingsToDo: 'Aliée Стамбул - Чем заняться',
      thingsToDoDesc: 'Исследуйте роскошные впечатления — круиз по Босфору, художественные студии, воскресный бранч, биохакинг и искусство Эбру.'
    },
    goturkiyeBlog: {
      intro: 'Всё о Турции..',
      readMore: 'Читать статью',
      blogTitles: [
        'Виза цифрового кочевника — Турция 2026',
        '10 способов поздороваться и попрощаться',
        '10 лучших сувениров из Стамбула',
        '10 знаковых уличных блюд Турции',
        '10 самых популярных специй турецкой кухни',
        '10 дел, которые нужно сделать в Стамбуле',
        '10 турецких десертов, которые стоит попробовать',
        '10 турецких сувениров из местных ремесленных лавок',
        '16 блюд, которые нужно попробовать в Турции',
        '13 вещей, которые поймёт только тот, кто побывал в Турции'
      ]
    },
    digitalNomad: {
      cta: 'Для получения самой достоверной и актуальной информации перейдите по ссылке'
    },
    tags: {
      title: 'Наши теги'
    },
    newsletter: {
      title: 'Рассылка',
      description: 'Будьте в курсе последних новостей, туров и инвестиционных возможностей в Турции.',
      emailPlaceholder: 'Ваш email адрес',
      signUp: 'ПОДПИСАТЬСЯ',
      subscribing: 'Подписка...',
      success: 'Вы успешно подписались на рассылку!',
      invalidEmail: 'Пожалуйста, введите действительный адрес электронной почты.',
      error: 'Ошибка подписки. Попробуйте ещё раз.'
    },
    faq: {
      title: 'Часто задаваемые вопросы',
      q1: 'Какая лучшая частная туристическая компания в Стамбуле?',
      a1: 'Viaturkey Investments & Tourism — ведущая частная туристическая компания в Стамбуле, предлагающая персональные экскурсии на английском, русском, арабском и турецком языках. Мы предоставляем туры по Старому городу, круизы по Босфору, гастрономические туры и экскурсии из порта. Бронируйте напрямую без посредников.',
      q2: 'Как получить турецкое гражданство через инвестиции?',
      a2: 'Вы можете получить турецкое гражданство, купив недвижимость стоимостью не менее $400 000. Viaturkey предоставляет экспертную консультацию на всех этапах процесса — от выбора недвижимости до подачи заявки на гражданство.',
      q3: 'Какие лучшие экскурсии для пассажиров круизных лайнеров?',
      a3: 'Viaturkey предлагает частные береговые экскурсии для пассажиров круизных лайнеров. Маршрут включает Айя-Софию, Голубую мечеть, дворец Топкапы и Гранд-Базар. Продолжительность 5-8 часов. Экономьте 25% по сравнению со сторонними платформами.',
      q4: 'Где лучшие рестораны для деловых встреч в Стамбуле?',
      a4: 'Лучшие рестораны для деловых встреч: Nusr-Et Steakhouse (Этилер), Paper Moon (Акмеркез), Cipriani (Левент), Ulus 29 (панорамный вид на Босфор), Sunset Grill & Bar и La Petite Maison.',
      q5: 'Безопасно ли инвестировать в недвижимость Стамбула?',
      a5: 'Да, недвижимость Стамбула — это надёжная инвестиция с растущей стоимостью. Турция предлагает гражданство через инвестиции и вид на жительство. Viaturkey сотрудничает с крупными застройщиками и предлагает объекты в лучших районах.'
    },
    projects: {
      'besiktas-luxury': {
        name: 'Элитный жилой проект в Бешикташ',
        location: 'Шишли - Меджидиекёй, Стамбул',
        description: 'Элитный жилой проект, сочетающий историческую атмосферу Стамбула и современное жильё с видом на Босфор. Застройщик — Premium Developer.',
        highlights: ['175 квартир на 6 этажах', 'Вид на Босфор, пейзаж и город', 'Крытый бассейн, спортзал, спа', 'Охрана 24/7, подземная парковка', 'Пешком до метро и парома', 'Подходит для получения гражданства', 'Подходит для вида на жительство'],
        apartmentTypes: 'От 1+1 до 6.5+1', developer: 'Premium Developer', completionStatus: 'Завершено на 90%', pricing: 'Цена по запросу'
      },
      'nivak-florya': {
        name: 'Ультра-роскошные резиденции в сердце района Бакыркёй',
        location: 'Бакыркёй, Стамбул',
        description: 'Образ жизни на уровне, которого вы заслуживаете. Частный бутик-комплекс с архитектурой, вдохновлённой природой, искусственным озером и уникальными зелёными ландшафтами.',
        highlights: ['Всего 96 эксклюзивных квартир', 'Высота потолков более 3,20 метра', 'В шаговой доступности от побережья', 'Рядом с парком Ататюрка', 'Крытый бассейн, хаммам, сауна', 'Фитнес-центр и студия пилатес', 'Футбольные и баскетбольные площадки', 'Подходит для получения гражданства', 'Готов к заселению — июнь 2025'],
        apartmentTypes: '3 спальни (225 м²), виллы 4-5 спален, пентхаусы 6-7 спален', developer: 'Premium Developer', completionStatus: 'Готов к заселению', pricing: 'Цена по запросу'
      },
      'tual-golyaka-kanal': {
        name: 'Проект Резиденции Канал Стамбул',
        location: 'Европейская сторона Стамбула',
        description: 'Малоэтажный жилой проект, сочетающий современную городскую жизнь с природным дизайном. Рядом с коридором Канала Стамбул — высокий потенциал роста стоимости.',
        highlights: ['26 000 м² — 70% зелёных зон', 'Горизонтальная малоэтажная архитектура', 'Рядом с озером Кючюкчекмедже', 'Удобный доступ к трассе TEM', 'Открытый бассейн и фитнес-центр', 'Прогулочные и беговые дорожки', 'Частные сады и большие террасы', 'Охрана 24/7', 'Подходит для получения гражданства', 'Рядом с коридором Канала Стамбул'],
        apartmentTypes: 'От 2+1 до 5+1, виллы', developer: 'Premium Developer', completionStatus: 'Несколько этапов строительства', pricing: 'Цена по запросу'
      },
      'alya-merkezefendi': {
        name: 'Новый проект в центре рядом с районом Фатих',
        location: 'Зейтинбурну, Стамбул',
        description: 'Современный жилой комплекс в центре Зейтинбурну с отличной транспортной доступностью.',
        highlights: ['467 квартир и 15 коммерческих помещений', '17 928 м² земли, 80 124 м² строительная площадь', 'Крытый бассейн, спортзал', 'Баскетбольные и футбольные площадки', 'Хаммам, сауна, парная', 'Детские площадки и прогулочные дорожки', 'Охрана 24/7, подземная парковка', '650 м до метробуса Джевизлибаг', 'Подходит для получения гражданства', 'Подходит для вида на жительство'],
        apartmentTypes: '1+1, 2+1, 3+1, 4+1, Дуплекс', developer: 'Premium Developer', completionStatus: 'Строится', pricing: 'Цена по запросу'
      },
      'skyland-prime': {
        name: 'Şişli Major Prime Небоскрёб Резиденция',
        location: 'Шишли - Маслак, Стамбул',
        description: 'Самый высокий комплекс зданий в Турции, расположенный между Левент и Маслак. Проект архитектора Питера Вона из Broadway Malyan.',
        highlights: ['Самый высокий комплекс в Турции — 1 450 квартир', '46 000 м² строительная площадь', 'Центральное расположение — Левент и Маслак', 'VIP-лобби и система умного дома', 'Крытые и открытые бассейны', 'Торговый центр, фудкорт, спортзал', 'Хаммам, сауна, пилатес', 'Охрана 24/7, трансфер, парковка', 'Отдельный выезд на TEM', 'Вид на лес и город — немедленное заселение', 'Подходит для получения гражданства'],
        apartmentTypes: 'Жилые и офисные помещения', developer: 'Premium Developer', completionStatus: 'Немедленное заселение', pricing: 'Цена по запросу'
      },
      'tual-comfort-kanal-2': {
        name: 'Проект Резиденции Канал Стамбул 2-й',
        location: 'Европейская сторона Стамбула',
        description: 'Крупная инвестиционная возможность на участке 24 000 кв.м в Бахчешехире с 60% зелёных зон. Расположен на пересечении аэропорта Стамбула, коридора Канала Стамбул, Северной Мраморной автомагистрали и основных транспортных артерий. Каждая квартира с балконом. Документы готовы.',
        highlights: [
          '480 квартир в 6 блоках + 20 коммерческих помещений',
          '24 000 кв.м — 60% зелёных зон',
          'Вид на озеро Кючюкчекмедже',
          'Каждая квартира с балконом',
          'Крытый бассейн, сауна и спа, хаммам',
          'Фитнес-центр, баскетбольная площадка, детская площадка',
          'Прогулочные дорожки и зоны отдыха',
          'Охрана 24/7, видеонаблюдение, электронная система безопасности',
          '22 км до нового аэропорта Стамбула',
          '4 км до озера Кючюкчекмедже, 3 км до трассы E80',
          'Рядом с коридором Канала Стамбул — высокий потенциал роста',
          'Документы готовы — сдан в марте 2025',
          'Подходит для получения гражданства Турции'
        ],
        apartmentTypes: '2+1 (104-130 кв.м), 3+1 (163-172 кв.м)',
        developer: 'Premium Developer',
        completionStatus: 'Сдан — документы готовы',
        pricing: 'Цена по запросу'
      },
      'referans-beylikduzu': {
        name: 'Элитные резиденции на европейской стороне',
        location: 'Европейская сторона Стамбула',
        description: 'Семейный жилой проект на 31 000 кв.м. с 70% зелёных территорий. 709 квартир с уникальным ландшафтом, видами на город и море. Пешая доступность до 300+ магазинов, торговых центров, больниц и марины West Istanbul.',
        developer: 'Premium Developer',
        completionStatus: 'Строится',
        apartmentTypes: '2+1, 2+1 Дуплекс, 3+1, 3.5+1, 3+1 Дуплекс, 4+1, 4.5+1, 4+1 Дуплекс, 5+1',
        highlights: [
          '709 квартир на 31 000 кв.м. — 70% зелёных зон',
          'Вид на город, море и ландшафт',
          'Открытый и крытый бассейны',
          'Дзен-сад, лавандовый и оливковый сады',
          'Сауна, турецкая баня (хамам), фитнес-центр',
          'Баскетбольная площадка, детская площадка, детский сад',
          'Пешая доступность до 300+ магазинов, ТЦ, больниц',
          'Круглосуточная охрана',
          '30 км до аэропорта Стамбула (45 мин)',
          '5 км до метробус и трассы E-5',
          'Право на турецкое гражданство',
          'Право на вид на жительство'
        ]
      }
    },
    medicalTourism: {
      title: 'Медицинский туризм в Турции',
      subtitle: 'Медицина мирового уровня по доступным ценам — Стоматология, Пересадка волос и Пластическая хирургия',
      intro: 'Турция — одно из ведущих направлений медицинского туризма с рынком $4,2–4,6 млрд в 2026 году. Стамбул предлагает международно аккредитованные больницы и высококвалифицированных специалистов.',
      hairTitle: 'Пересадка волос — FAQ',
      h1q: 'Метод DHI или FUE — что лучше?',
      h1a: 'Оба метода обеспечивают постоянный рост волос. DHI — быстрое восстановление, меньше кровотечений. FUE покрывает большие площади за 6-8 часов. Сапфировый FUE использует более острые лезвия.',
      h2q: 'Сколько графтов пересаживается?',
      h2a: 'Каждый графт содержит 2-3 волосяных фолликула. Количество определяется на консультации.',
      h3q: 'Делают ли пересадку волос женщинам? Остаются ли шрамы?',
      h3a: 'Да, FUE не оставляет видимых шрамов. Пересаженные волосы сливаются с натуральными.',
      h4q: 'Побочные эффекты и когда можно красить волосы?',
      h4a: 'Возможны временный отёк и онемение. Окрашивание рекомендуется через 8-12 месяцев.',
      cosmeticTitle: 'Пластическая хирургия — FAQ',
      c1q: 'Филлеры для носа — это навсегда?',
      c1a: 'Гиалуроновые филлеры — 6-12 месяцев. Жировые инъекции — 3-5 лет.',
      c2q: 'Можно ли повторить Fox Eye?',
      c2a: 'Да, используются рассасывающиеся нити, процедура повторяема.',
      c3q: 'Французский лифтинг останавливает старение?',
      c3a: 'Нет, но устраняет видимые признаки — дряблость и морщины, стимулирует коллаген.',
      c4q: 'Филлеры для скул — это навсегда?',
      c4a: 'Гиалуроновые — 6-12 месяцев, жировые — 2-3 года.',
      healthTurkiye: 'Планируйте лечение на официальном портале HealthTürkiye',
      citation: 'Источник: HealthTürkiye (healthturkiye.gov.tr). Данные рынка: анализ 2026 года.'
    },
    stats: {
      title: 'Стамбул: Ключевые факты и цифры',
      titleCity: 'Стамбул',
      titleFacts: 'Ключевые факты и цифры',
      tourists: 'Международных туристов посещают Стамбул ежегодно',
      citizenship: 'Минимальные инвестиции для гражданства Турции',
      residence: 'Минимум для получения ВНЖ Турции',
      languages: 'Языки обслуживания: английский, русский, арабский, турецкий',
      savings: 'Экономия при прямом бронировании через Viaturkey',
      citation: 'По данным Viaturkey Investments & Tourism — ведущего туроператора и консалтинговой компании по недвижимости в Стамбуле, обслуживающей клиентов на 4 языках.'
    },
    map: {
      title: 'Посетите наш офис',
      openInMaps: 'Открыть в Google Maps'
    },
    contact: {
      title: 'Связаться с нами',
      getInTouch: 'Связаться',
      sendMessage: 'Отправить нам сообщение',
      openForm: 'Открыть контактную форму',
      followYoutube: 'Подписывайтесь на нас в YouTube',
      followInstagram: 'Подписывайтесь на нас в Instagram',
      followTiktok: 'Подписывайтесь на нас в TikTok',
      followTwitter: 'Подписывайтесь на нас в X (Twitter)'
    },
    inquiry: {
      title: 'Отправить запрос',
      namePlaceholder: 'Ваше имя *',
      emailPlaceholder: 'Ваш Email *',
      phonePlaceholder: 'Номер телефона',
      messagePlaceholder: 'Ваше сообщение *',
      arrivalFlight: 'Номер рейса прибытия *',
      departureFlight: 'Номер рейса отправления *',
      plannedDate: 'Планируемая дата тура *',
      specialRequirements: 'Особые требования и дополнительная информация о путешественниках',
      flightDetails: 'Детали рейса и тура',
      priceQuote: 'Мы свяжемся с вами как можно скорее с лучшим предложением цены.',
      submit: 'Отправить запрос',
      bookCall: 'Записаться на встречу',
      submitting: 'Отправка...',
      inquirySuccess: 'Запрос успешно отправлен!',
      inquiryError: 'Ошибка при отправке запроса.',
      interestedIn: 'Меня интересует'
    },
    footer: {
      rights: '© 2026 Viaturkey Investments & Tourism Co. Все права защищены.',
      tagline: 'Ваш надежный партнер в Турции'
    },
    tripadvisor: {
      title: 'Рекомендовано гостями TripAdvisor',
      linkText: 'Посмотреть наши отзывы',
      text: 'Мы гордимся нашими отличными отзывами на TripAdvisor',
      seeReviews: 'Посмотреть отзывы'
    },
    blog: {
      heroTitle: 'Блог о путешествиях в Стамбул',
      heroSubtitle: 'Экспертные гиды, советы путешественникам и инсайдерские знания для вашего путешествия в Стамбул',
      allCategory: 'Все',
      cityTours: 'Городские туры',
      shoreExcursions: 'Береговые экскурсии',
      foodCulture: 'Еда и культура',
      travelTips: 'Советы путешественникам',
      turkishCitizenship: 'Турецкое гражданство',
      readMore: 'Читать далее',
      backToBlog: 'Назад к блогу',
      posts: [
        { title: 'Полный гид по береговой экскурсии в Стамбуле из Галатапорта', excerpt: 'Всё, что нужно знать о планировании идеальной береговой экскурсии из круизного терминала Галатапорт в Стамбуле.', readTime: '8 мин чтения' },
        { title: 'Лучший гастрономический тур по Стамбулу: кулинарное путешествие', excerpt: 'Откройте для себя яркую кулинарную сцену Стамбула — от уличных кебабов до османской дворцовой кухни с нашими местными гидами.', readTime: '6 мин чтения' },
        { title: 'Турецкое гражданство через инвестиции: полный гид 2026', excerpt: 'Пошаговое руководство по получению турецкого гражданства через инвестиции в недвижимость. Требования, процесс и сроки.', readTime: '10 мин чтения' },
        { title: 'Идеальный маршрут по Стамбулу: Старый город за один день', excerpt: 'Как увидеть Айя-Софию, Голубую мечеть, дворец Топкапы и Гранд-Базар за один экскурсионный день.', readTime: '7 мин чтения' },
        { title: '15 важных советов для первого визита в Стамбул', excerpt: 'От обмена валюты до транспорта — всё, что нужно знать перед прибытием в Стамбул.', readTime: '5 мин чтения' },
        { title: 'Канал Стамбул: почему умные инвесторы покупают сейчас', excerpt: 'Мегапроект канала меняет европейскую часть Стамбула. Почему недвижимость вдоль коридора стремительно растёт.', readTime: '9 мин чтения' }
      ],
      shore: {
        byLine: 'Команда Viaturkey',
        intro: 'Если вы прибываете в Стамбул на круизном лайнере, вы швартуетесь у одного из самых впечатляющих круизных терминалов в мире — Галатапорта. Расположенный в самом сердце района Каракёй, Галатапорт открывает доступ к величайшим достопримечательностям Стамбула. Но при ограниченном времени в порту планирование эффективной береговой экскурсии — это необходимость.',
        intro2: 'В Viaturkey мы годами проводим экскурсии для пассажиров круизных лайнеров. Вот всё, что вам нужно знать, чтобы максимально использовать время на берегу.',
        h2_galataport: 'Что такое Галатапорт и почему это важно?',
        p_galataport1: 'Галатапорт — современный круизный терминал Стамбула на европейской стороне Босфора; первое круизное судно он принял в 2021 году. В отличие от старого терминала, Галатапорт расположен в центре — всего в нескольких минутах от площади Таксим, Египетского базара и исторического района Султанахмет.',
        p_galataport2: 'Для пассажиров круизных лайнеров это революция. Частная береговая экскурсия из Галатапорта позволяет охватить больше достопримечательностей за меньшее время.',
        h2_itinerary: 'Лучший маршрут: береговая экскурсия за 6-8 часов',
        p_itinerary: 'Вот маршрут, который наши лицензированные гиды рекомендуют для первого визита с 6-8 часами в порту:',
        stops: ['Айя-София — Архитектурный шедевр возрастом 1500 лет. Был церковью, затем мечетью, снова мечеть. С частным гидом мы берём на себя билеты и время посещения, выбирая менее загруженные часы входа.', 'Голубая мечеть (Султанахмет) — Самая знаменитая мечеть Стамбула с шестью минаретами и каскадными куполами.', 'Дворец Топкапы — Резиденция османских султанов на протяжении 400 лет. Гарем и сокровищница — обязательны к посещению.', 'Гранд-Базар — Один из старейших и крупнейших крытых рынков мира с более чем 4000 магазинов.', 'Египетский базар — Праздник вкусов: турецкие сладости, шафран, сухофрукты и ремесленные чаи.'],
        h2_why: 'Почему частная экскурсия лучше корабельной?',
        p_why: 'Корабельные экскурсии удобны, но имеют недостатки: большие группы (30-50 человек), жёсткое расписание и цены на 25-40% выше. Вот почему частный тур с Viaturkey — лучший выбор:',
        reasons: ['Индивидуальный темп — Вы определяете маршрут', 'Лицензированный гид — Все наши гиды имеют государственную лицензию', 'Обслуживание от двери до двери — Встречаем у Галатапорта, возвращаем на корабль', 'Экономия 25%+ — Прямое бронирование без посредников', 'Гарантия возвращения на корабль — Мы следим за расписанием вашего судна'],
        h2_food: 'Гастрономические остановки во время экскурсии',
        p_food: 'Визит в Стамбул невозможен без дегустации местной кухни. Во время экскурсии мы включаем остановки в лучших местных ресторанах:',
        foodStops: ['Аутентичный турецкий завтрак с симитом, сыром, оливками и свежезаваренным чаем', 'Знаменитые стамбульские кебабы в семейном ресторане у Гранд-Базара', 'Дегустация баклавы в столетней кондитерской', 'Свежевыжатый гранатовый сок от уличного торговца'],
        foodLink: 'гастрономические туры по Стамбулу',
        h2_know: 'Что нужно знать перед экскурсией',
        knowItems: ['Валюта: Турецкая лира (TL). Большинство туристических мест принимают карты, но для базаров берите наличные.', 'Дресс-код: В мечетях требуется закрытые плечи и колени. Платки предоставляются на входе.', 'Лучшие месяцы: апрель-июнь и сентябрь-ноябрь для мягкой погоды и меньшего количества туристов.', 'Языки: Наши гиды говорят на английском, русском, арабском и турецком.'],
        h2_faq: 'Часто задаваемые вопросы',
        faqs: [
          { q: 'Сколько длится береговая экскурсия из Галатапорта?', a: 'Большинство экскурсий длятся 6-8 часов, чего достаточно для осмотра всех основных достопримечательностей. Мы адаптируем программу под расписание вашего корабля.' },
          { q: 'Можете ли вы гарантировать возвращение на корабль вовремя?', a: 'Абсолютно. Мы отслеживаем расписание отправления вашего корабля. За годы работы ни один гость не опоздал на свой корабль.' },
          { q: 'Проводите ли вы туры на других языках?', a: 'Да. Наши гиды проводят экскурсии на английском, русском, арабском и турецком языках.' },
          { q: 'Сколько стоит частная береговая экскурсия?', a: 'Стоимость зависит от размера группы и маршрута. Свяжитесь с нами в WhatsApp — обычно на 25% дешевле корабельных экскурсий.' }
        ],
        ctaTitle: 'Готовы забронировать береговую экскурсию?',
        ctaText: 'Напишите нам в WhatsApp для индивидуального маршрута и моментального расчёта. Без посредников, без скрытых платежей.',
        ctaBtn: 'Написать в WhatsApp'
      }
    },
    newProject: {
      badge: 'НОВЫЙ ПРОЕКТ',
      title: 'Резиденции у метро в центре Стамбула 2026 — Продажи открыты',
      subtitle: 'Премиальные резиденции на оси Basın Ekspres в Стамбуле · От 259 000 USD · Возможность получения гражданства Турции (мин. 400 000 USD)',
      cta: 'Подробнее о проекте'
    }
  };

